import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText } from "vue"

const _hoisted_1 = { class: "p-jobsearch-search_section" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h3", { class: "p-jobsearch-search_hl" }, [
  /*#__PURE__*/_createTextVNode("キーワード "),
  /*#__PURE__*/_createElementVNode("div", { class: "p-jobsearch-tooltip js-tooltip-container __sp-center" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "p-jobsearch-tooltip_close js-tooltip-close-trigger" }, "閉じる")
  ])
], -1)
const _hoisted_3 = { class: "p-jobsearch-search_keyword" }
const _hoisted_4 = ["value"]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "p-jobsearch-search_keyword_span" }, "に", -1)
const _hoisted_6 = { class: "p-jobsearch-search_keyword" }
const _hoisted_7 = ["placeholder"]
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "p-jobsearch-search_keyword_span" }, "を含む", -1)

import { ref, watch, onMounted } from 'vue';

// 親コンポーネントからのプロパティを定義

export default /*#__PURE__*/_defineComponent({
  __name: 'Keyword',
  props: {
    modelValue: null
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'update:modelValue', value: { field?: string; value?: string }): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  modelValue?: { field?: string; value?: string }
}



// 親コンポーネントへのイベントを定義


// ドロップダウンのデータ
const keywordData = [
  { value: 'company_name', text: '会社名', placeholder: 'スペース区切りで入力（AND検索）'},
  { value: 'job_description', text: '仕事内容', placeholder: 'スペース区切りで入力（AND検索）'},
  { value: 'job_skills', text: '求める人材(経験・スキル)', placeholder: 'スペース区切りで入力（OR検索）'},
];

// コンポーネントのローカル状態
const selectedField = ref<string | undefined>(keywordData[0].value);
const inputValue = ref<string | undefined>('');
const placeholderText = ref(keywordData[0].placeholder);

// データを更新して親コンポーネントに送信する関数
function updateKeywordData() {
  emit('update:modelValue', {
    field: selectedField.value ? selectedField.value : keywordData[0].value,
    value: inputValue.value
  });
}

// プロパティからのデータをコンポーネントに同期する
watch(() => props.modelValue, (newValue) => {
  if (newValue?.field) {
    selectedField.value = newValue.field;
  } else {
    selectedField.value = keywordData[0].value;
  }
  inputValue.value = newValue?.value;
  placeholderText.value = keywordData.filter(x => x.value == selectedField.value)[0].placeholder;
}, { immediate: true });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _withDirectives(_createElementVNode("select", {
        class: "p-jobsearch-search_keyword_select",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedField).value = $event)),
        onChange: updateKeywordData
      }, [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(keywordData, (kw) => {
          return _createElementVNode("option", {
            key: kw.value,
            value: kw.value
          }, _toDisplayString(kw.text), 9, _hoisted_4)
        }), 64))
      ], 544), [
        [_vModelSelect, selectedField.value]
      ]),
      _hoisted_5
    ]),
    _createElementVNode("div", _hoisted_6, [
      _withDirectives(_createElementVNode("input", {
        class: "p-jobsearch-search_keyword_txt",
        type: "text",
        placeholder: placeholderText.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((inputValue).value = $event)),
        onChange: updateKeywordData
      }, null, 40, _hoisted_7), [
        [_vModelText, inputValue.value]
      ]),
      _hoisted_8
    ])
  ]))
}
}

})